var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 20 20",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.56 6.95-.17-.31-2.01 1.16.15.29c.48.9.72 1.88.72 2.89 0 3.44-2.8 6.24-6.24 6.24s-6.24-2.8-6.24-6.24c0-3.33 2.62-6.06 5.9-6.24v1.74l4.21-3.02-4.22-3.01v1.97c-4.57.18-8.23 3.95-8.23 8.56 0 4.73 3.84 8.57 8.57 8.57s8.57-3.84 8.57-8.57c0-1.4-.35-2.8-1.01-4.03z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.ab785b6f3e83b32164c1960c61ca8f4a.svg";
export { ForwardRef as ReactComponent };